// 원장 호출 — 카드·전체 화면·데스크 띠가 같이 쓰는 작은 조각들
import React from 'react';
import { situationLabel, toMs, fmtMSS } from '../../../utils/doctorCall';

// 원장실 재실/부재 표시 (present: true | false | null=미설정)
export function PresenceChip({ present, big }) {
    const base = { display: 'inline-flex', alignItems: 'center', gap: 6, borderRadius: 999, padding: big ? '5px 14px' : '2px 10px', fontSize: big ? 16 : 12, fontWeight: 700, whiteSpace: 'nowrap' };
    if (present === true) return <span style={{ ...base, background: '#e2f0ec', color: '#1A8F6F' }}>{'원장실 재실'}</span>;
    if (present === false) return <span style={{ ...base, background: '#e5e7eb', color: '#4b5563' }}>{'원장실 부재 — 직접 찾아가기'}</span>;
    return <span style={{ ...base, background: '#f5f7f6', color: '#7a8783', border: '1px solid #d9dfdc' }}>{'원장실 재실/부재 미설정'}</span>;
}

// 연결 끊김 회색 띠 — 호출 버튼 비활성 안내
export function DisconnectBand({ loaded }) {
    return (
        <div role="status" style={{ background: '#e5e7eb', color: '#374151', borderRadius: 8, padding: '8px 12px', fontSize: 13.5, fontWeight: 700 }}>
            {loaded ? '연결 끊김 — 인터넷이 다시 연결될 때까지 호출 버튼을 누를 수 없습니다.' : '연결 중…'}
        </div>
    );
}

// 미응답 대표 1건 문구 + 외 N건
export function overdueText(overdue, settings, nowMs) {
    if (!overdue.length) return '';
    const c = overdue[0];
    const w = nowMs - toMs(c.createdAt);
    const more = overdue.length > 1 ? ` 외 ${overdue.length - 1}건` : '';
    return `${c.chairNo}번 체어 · ${situationLabel(c.situation, settings)} · 원장 미응답 ${fmtMSS(Number.isFinite(w) ? w : 0)}${more}`;
}

// 데스크 버튼 2개 — [원장실로 전화](기록만 — 전화를 걸지 않음) · [방문객 있음]. 데스크는 호출을 만들거나 끄지 못한다
export function DeskButtons({ overdue, dc, compact }) {
    const allCalled = overdue.length > 0 && overdue.every(c => !!c.deskCalledAt);
    const allVisitor = overdue.length > 0 && overdue.every(c => !!c.deskVisitorAt);
    const btn = { border: '1px solid #b45309', background: '#fff', color: '#92400e', borderRadius: 7, padding: compact ? '4px 10px' : '6px 14px', fontSize: compact ? 12.5 : 13.5, fontWeight: 700, cursor: 'pointer', minHeight: 32 };
    const done = { ...btn, background: '#fef3c7', cursor: 'default' };
    const disabled = !dc.connected;
    return (
        <span style={{ display: 'inline-flex', gap: 6, flexWrap: 'wrap' }}>
            <button type="button" disabled={disabled || allCalled}
                onClick={() => dc.deskAct(overdue.filter(c => !c.deskCalledAt), 'called')}
                title="원장실로 전화한 것을 기록합니다(전화를 걸지는 않습니다)"
                style={allCalled ? done : btn}>
                {allCalled ? '전화함 ✓' : '원장실로 전화'}
            </button>
            <button type="button" disabled={disabled || allVisitor}
                onClick={() => dc.deskAct(overdue.filter(c => !c.deskVisitorAt), 'visitor')}
                title="원장 보기 화면에 「데스크: 방문객 있음」을 띄웁니다"
                style={allVisitor ? done : btn}>
                {allVisitor ? '방문객 있음 기록됨 ✓' : '방문객 있음'}
            </button>
        </span>
    );
}
